<div class="activity-card primary-border">
  <div class="number">
    <h4>{{ number }}</h4>
  </div>
  <div class="title">
    <h5>{{ title }}</h5>
  </div>
  <div class="text">
    <p>{{ text }}</p>
  </div>
</div>
